/// <amd-module name="Feed/Legacy/Protocols/UPack/UPackConstants" />
import { PerfScenarios } from "Feed/Common/Constants/Constants";
import { Feed } from "Feed/Common/Contracts/Feed";

export const UPackKey = "upack";
export const UPackKeyCapitalized = "UPack";

/**
 * Perfomance scenario constants.
 */
export class UPackPerfScenarios extends PerfScenarios {
    public static DeletePackage = "Packaging.Package.UPack.RemovePackage";
}

export class UPackCiConstants {
    public static ProtocolName = "UPack";
    public static UPackConnectToFeedPanel = "UPackConnectToFeedPanel";
}

export type UPackGetPublishCommand = (
    feed: Feed,
    pkgName: string,
    version: string,
    pkgDescription: string,
    separator: string
) => string;
